import React from 'react';
import Button from '../../../common/navigation/Button';

const UpdateCardQuarterly: React.FC<{
  displayAdvantages: boolean;
  displayButton: boolean;
  handleChange?: () => void;
  price: number;
  title: string;
}> = ({ displayAdvantages, displayButton, handleChange, price, title }) => {
  return (
    <div
      className="card card-subscription-quarterly card-plan card-plan-quarterly plan"
      style={displayAdvantages ? {} : { height: '250px' }}
    >
      <div className="card-header-title">
        <span>{title}</span>
      </div>
      <div className="card-title">
        <h3>Trimestriel</h3>
      </div>
      <h1>
        {price}€<sup className="large">HT</sup>
      </h1>
      <h4 className="under-price">Facturé tous les 3 mois</h4> <br />
      {displayAdvantages && (
        <ul className="check-list">
          <li className="icon-quarterly">
            <b>Exclusivité</b> des chantiers
          </li>
          <li className="icon-quarterly">
            <b>Adaptés</b> à votre activité
          </li>
          <li className="icon-quarterly">
            Accès <b>illimité</b> aux consultations
          </li>
          <li className="icon-quarterly">
            Abonnement <b>sans engagement</b>
          </li>
        </ul>
      )}
      {displayButton && (
        <div className="button">
          <Button color="btn-secondary" text={"Je m'abonne"} action={() => handleChange()} />
        </div>
      )}
    </div>
  );
};

export default UpdateCardQuarterly;
